import * as Yup from 'yup';
import { phoneNumberFormatter } from './phoneNumber.validation';

export const OnboardingProfileSchema = Yup.object().shape({
  companyName: Yup.string().nullable().label('Company name').required(),
  contactPhoneNumber: Yup.string()
    .nullable()
    .label('Contact phone number')
    .max(16, 'Maximum 16 Characters.')
    .required('Please enter a valid phone number')
    .test(
      'validate-cpnumber',
      'Please enter a valid phone number',
      (value): any => {
        if (value) {
          return phoneNumberFormatter({ phoneNumber: value || '' }).isValid();
        }
        return true;
      }
    )
});
